import {h, Fragment} from "preact"
import { useEffect, useRef } from "preact/hooks"

export default function Carousel({ wrapperUniqueClass, carouselClass, options, init, children }) {
    const carouselRef = useRef(null);

    // useEffect(() => {
    //     if(!window.Swiper || !children?.length > 1 || !carouselRef.current || !init) return;
        
    //     if(carouselRef.current.swiper) {
    //         carouselRef.current.swiper.destroy(true, true);
    //         carouselRef.current.swiper = null;
    //     }
        
    //     if(options.navigation?.nextEl && options.navigation?.prevEl) {
    //         options.navigation.prevEl = `.${wrapperUniqueClass} .swiper-button-prev`;
    //         options.navigation.nextEl = `.${wrapperUniqueClass} .swiper-button-next`;
    //     }
    //     if(options.pagination?.el) {
    //         options.pagination.el = `.${wrapperUniqueClass} .swiper-pagination`;
    //     }
    //     const instance = new Swiper(carouselRef.current, options);
    //     carouselRef.current.swiper = instance;

    //     return () => {
    //         if(carouselRef.current?.swiper) {
    //             carouselRef.current.swiper.destroy(true, true);
    //             carouselRef.current.swiper = null;
    //         };
    //     };
    // }, [ children ])


    // @Vlad: I commented the script above and did the one below in order to fix the point 1. in this comment https://nostosolutions.atlassian.net/browse/FEA-11263?focusedCommentId=381867
    // if this creates some problem, remove my script and re-add your original one

    useEffect(() => {
        if (!window.Swiper || !(children?.length > 1) || !carouselRef.current || !init) return;
    
        if (!carouselRef.current.swiper) { // only init if not already there
            if (options.navigation?.nextEl && options.navigation?.prevEl) {
                options.navigation.prevEl = `.${wrapperUniqueClass} .swiper-button-prev`;
                options.navigation.nextEl = `.${wrapperUniqueClass} .swiper-button-next`;
            }
            if (options.pagination?.el) {
                options.pagination.el = `.${wrapperUniqueClass} .swiper-pagination`;
            }
            const instance = new Swiper(carouselRef.current, options);
            carouselRef.current.swiper = instance;
        }
    
        return () => {
            if (carouselRef.current?.swiper) {
                carouselRef.current.swiper.destroy(true, true);
                carouselRef.current.swiper = null;
            }
        };
    }, [init]);

    return (
        <div className={`${wrapperUniqueClass ? wrapperUniqueClass : ''} ${carouselClass ? carouselClass : ''} ns-d-flex`}>
            {(init && options.navigation) && (
                <button type="button" className="swiper-button swiper-button-prev w-7 h-8 items-center justify-center flex" onClick={(e)=>e.stopPropagation()}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <polyline points="15,18 9,12 15,6"></polyline>
                    </svg>
                </button>
            )}
            <div
            // w-full
                className="swiper ns-w-100 ns-d-flex ns-flex-nowrap"
                ref={carouselRef}
            >
                <div className={`swiper-wrapper ${!init ? "ns-justify-content-center" : ""}`}>
                    {children}
                </div>
                {(init && options.pagination) && (
                    <div className="swiper-pagination absolute bottom-0 left-0 right-0 flex w-full h-0.5 z-1"></div>
                )}
            </div>
            {(init && options.navigation) && (
                <button type="button" className="swiper-button swiper-button-next w-7 h-8 items-center justify-center flex" onClick={(e)=>e.stopPropagation()}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <polyline points="9,18 15,12 9,6"></polyline>
                    </svg>
                </button>
            )}
        </div>
    )
}
